import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export const resendPaymentRequest = async (
  paymentRequestId: string
) => {
  await api.post(
    `/services/payments/${paymentRequestId}/resend/`
  )

  queryClient.invalidateQueries([
    PAYMENT_REQUESTS_QUERY_KEY,
  ])
}
